import { useMemo } from 'react'
import HeroSection from './sub-sections/hero/HeroSection'
import { MetaDataContext, useMetaDataContext } from '../state-management/contexts/MetaDataContext'
import { powerPerformanceRankData } from '../data/powerPerformanceRankData'
import {
  MutualFundDetailSections,
  WaterfallSections,
  WaterfallValues
} from '../types/mutual-fund-detail.types'

export function MutualFundLockedHeroMock() {
  const parentContext = useMetaDataContext()

  const mockContextValue = useMemo(() => {
    const metadata = parentContext.data

    return {
      ...parentContext,
      data: metadata
        ? {
            ...metadata,
            sectionAvailability: {
              ...metadata.sectionAvailability,
              [WaterfallSections.HERO]: WaterfallValues.YES
            }
          }
        : metadata,
      powerPerformanceRankData: { data: powerPerformanceRankData },
      isPowerPerformanceRankLoading: false,
      isPowerPerformanceRankSuccess: true,
      isPowerPerformanceRankError: false,
      // HeroSection calls these handlers on mount; parent handlers still update MetaDataProvider
      // even inside this nested provider. Mock rank data is ELITE + off-track, which would
      // otherwise flip isUserElite / powerForm and open NotRecommendedFund on the execution bar.
      handleIsUserElite: () => {},
      handlePowerForm: () => {},
      handlePowerPerformanceRiveState: () => {}
    }
  }, [parentContext])

  return (
    <MetaDataContext.Provider value={mockContextValue}>
      <HeroSection sectionKey={MutualFundDetailSections.RETURNS_GRAPH} />
    </MetaDataContext.Provider>
  )
}
